import { render, staticRenderFns } from "./AddItemToCart.vue?vue&type=template&id=788cde2c&"
import script from "./AddItemToCart.vue?vue&type=script&lang=ts&"
export * from "./AddItemToCart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports